<template>
  <div class="inspection-failed-page">
    <div class="page-header" style="background:linear-gradient(135deg,#a61d24,#ff4d4f);">
      <div class="back-btn" @click="goBack">{{ $t('wholesaler.AfterSalesInspectionFailed.line4_text') }}</div>
      <h1>{{ $t('wholesaler.AfterSalesInspectionFailed.line5_text') }}</h1>
      <div class="sub">{{ detail.afterSalesNo }}</div>
    </div>

    <div v-loading="loading" class="content">
      <!-- 异常信息 -->
      <div class="module" style="border:2px solid #ff4d4f;">
        <div class="module-header" style="background:#fff2f0;color:#ff4d4f;">
          <span class="icon">⚠️</span><span class="title">{{ $t('wholesaler.AfterSalesInspectionFailed.line13_text') }}</span>
        </div>
        <div class="module-body">
          <div class="failed-item" v-for="item in failedItems" :key="item.productId">
            <div class="fi-header">
              <span class="fi-name">{{ item.productName }}</span>
              <span class="fi-qty">退回: {{ item.returnQuantity }} 件</span>
            </div>
            <div class="fi-result" :class="resultClass(item.inspectionResult)">
              {{ resultText(item.inspectionResult) }}
            </div>
            <div class="fi-note" v-if="item.inspectionNote">备注: {{ item.inspectionNote }}</div>
          </div>
        </div>
      </div>

      <!-- 处理方式选择 -->
      <div class="module">
        <div class="module-header"><span class="icon">🔧</span><span class="title">{{ $t('wholesaler.AfterSalesInspectionFailed.line31_text') }}</span></div>
        <div class="module-body">
          <el-radio-group v-model="form.processMethod" style="width:100%;">
            <el-radio label="SCRAP" style="display:block;margin-bottom:12px;padding:10px;border:1px solid #f0f0f0;border-radius:6px;">
              <div class="pm-title">{{ $t('wholesaler.AfterSalesInspectionFailed.line35_text') }}</div>
              <div class="pm-desc">{{ $t('wholesaler.AfterSalesInspectionFailed.line36_text') }}</div>
            </el-radio>
            <el-radio label="PARTIAL_REFUND" style="display:block;margin-bottom:12px;padding:10px;border:1px solid #f0f0f0;border-radius:6px;">
              <div class="pm-title">{{ $t('wholesaler.AfterSalesInspectionFailed.line39_text') }}</div>
              <div class="pm-desc">{{ $t('wholesaler.AfterSalesInspectionFailed.line40_text') }}</div>
            </el-radio>
            <el-radio label="RENEGOTIATE" style="display:block;margin-bottom:12px;padding:10px;border:1px solid #f0f0f0;border-radius:6px;">
              <div class="pm-title">{{ $t('wholesaler.AfterSalesInspectionFailed.line43_text') }}</div>
              <div class="pm-desc">{{ $t('wholesaler.AfterSalesInspectionFailed.line44_text') }}</div>
            </el-radio>
          </el-radio-group>

          <el-input v-model="form.processNote" type="textarea" :rows="3" :placeholder="$t('wholesaler.AfterSalesInspectionFailed.line48_placeholder')" maxlength="500" show-word-limit style="margin-top:12px;"></el-input>
        </div>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="bottom-actions">
      <el-button @click="goBack" style="flex:1;">{{ $t('common.cancel') }}</el-button>
      <el-button type="warning" @click="submitProcess" :loading="submitting" style="flex:2;">{{ $t('wholesaler.AfterSalesInspectionFailed.line56_text') }}</el-button>
    </div>
  </div>
</template>

<script>
import { getAfterSalesDetail, getReturnRecords } from '@/services/afterSales';

export default {
  name: 'AfterSalesInspectionFailed',
  data() {
    return {
      loading: false,
      submitting: false,
      detail: {},
      failedItems: [],
      form: {
        processMethod: 'SCRAP',
        processNote: ''
      }
    };
  },
  created() { this.loadDetail(); },
  methods: {
    async loadDetail() {
      this.loading = true;
      try {
        const id = this.$route.params.id;
        this.detail = await getAfterSalesDetail(id);
        // 获取退货记录，筛选不通过的项
        try {
          const records = await getReturnRecords(id);
          this.failedItems = (records || []).filter(r => r.inspectionResult !== 'PASSED');
        } catch {
          // 如果没有退货记录，从退回商品列表推导
          if (this.detail.returnItems) {
            const items = JSON.parse(this.detail.returnItems);
            this.failedItems = items.map(i => ({
              productId: i.productId,
              productName: i.productName,
              returnQuantity: i.quantity,
              inspectionResult: this.detail.returnInspectionResult || 'FAILED',
              inspectionNote: this.detail.inspectionNote || ''
            }));
          }
        }
      } catch (e) {
        this.$message.error('加载失败: ' + (e.message || e));
      } finally { this.loading = false; }
    },
    goBack() { this.$router.back(); },
    resultText(r) { const m = { FAILED:'❌ 不通过', PARTIAL:'⚠️ 部分通过' }; return m[r] || r; },
    resultClass(r) { return r === 'FAILED' ? 'result-failed' : 'result-partial'; },
    async submitProcess() {
      if (!this.form.processMethod) {
        this.$message.warning('请选择处理方式');
        return;
      }
      this.submitting = true;
      try {
        // TODO: 调用后端接口提交处理
        // await submitInspectionProcess(this.detail.id, this.form);
        this.$message.warning('此功能开发中，请联系技术支持');
        this.$router.push(`/wholesaler/after-sales/${this.detail.id}`);
      } catch (e) {
        this.$message.error('提交失败: ' + (e.message || e));
      } finally { this.submitting = false; }
    }
  }
};
</script>

<style scoped>
.page-header { color: #fff; padding: calc(16px + env(safe-area-inset-top, 0px)); }
.back-btn { font-size: 12px; opacity: 0.8; cursor: pointer; margin-bottom: 4px; }
.back-btn:hover { opacity: 1; }
.page-header h1 { font-size: 17px; }
.page-header .sub { font-size: 12px; opacity: 0.8; }

.content { max-width: 600px; margin: 0 auto; padding-bottom: 60px; background: #f5f5f5; min-height: calc(100vh - 80px); }

.module { margin: 8px; background: #fff; border-radius: 8px; overflow: hidden; }
.module-header { display: flex; align-items: center; padding: 12px 12px 8px; gap: 6px; border-bottom: 1px solid #f0f0f0; }
.module-header .icon { font-size: 16px; }
.module-header .title { font-size: 14px; font-weight: 600; flex: 1; }
.module-body { padding: 12px; }

.failed-item { padding: 10px; border: 1px solid #fff1f0; border-radius: 6px; margin-bottom: 8px; background: #fffafa; }
.fi-header { display: flex; justify-content: space-between; }
.fi-name { font-size: 14px; font-weight: 500; }
.fi-qty { font-size: 12px; color: #999; }
.fi-result { font-size: 13px; font-weight: 500; margin-top: 4px; }
.result-failed { color: #ff4d4f; }
.result-partial { color: #faad14; }
.fi-note { font-size: 11px; color: #999; margin-top: 4px; }

.pm-title { font-size: 13px; font-weight: 600; }
.pm-desc { font-size: 11px; color: #999; margin-top: 2px; }

.bottom-actions { position: sticky; bottom: 0; background: #fff; border-top: 1px solid #e8e8e8; padding: 12px; display: flex; gap: 8px; }
</style>
